import React, { useEffect } from 'react';

import routes from 'app/routes';

import {
  Outlet, useNavigate, ScrollRestoration,
} from 'react-router-dom';

export default function Index() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(routes.members.programs.new_ai.goals, { replace: true });
  }, []);

  return (
    <>
      <Outlet />
      <ScrollRestoration />
    </>

  );
}
